import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { isLogin } from './authorization/auth';
import Dashboard from './Dashboard';
import Login from './authorization/login';
import WorkInProgress from './work_in_progress';
import EnterpriseSelect from './authorization/enterprise_select';
import FileNotFound from './not_found';
import Logout from './authorization/logout';
import DeskBooking from './booking/desk';
import OrgBooking from './booking/org';
import ClientList from './client/client_list';
import NewClient from './client/new_client';
import EmployeeList from './employee/employee_list';
import VendorList from './vendor/vedor_list';
import Packaging from './booking/packaging';
import Pickup from './booking/pickup';
import UserList from './users/users_list';
import Products from './products/products';
import Invoices from './invoices/invoices';
import EditHome from './edit/edit_home';
import DeskCnEdit from './edit/desk_cn_edit';
import OrgCnEdit from './edit/org_cn_edit';
import OrgCnPickup from './edit/org_pickup_edit';
import OrgCnPackaging from './edit/org_packaging_edit';
import BillingCompany from './billing/billing_company';
import Billing from './billing/billing';
import InsuranceEdit from './edit/insurance_edit';
import Insurance from './booking/insurance';
import CompanyInvoices from './invoices/company_invoice';
import Admin from './admin_menu/admin';
import QuotationMaker from './quotation/quotation_maker';
import ServiceRequest from './ticket/service_request';
import InvoicesView from './invoices/view_invoice';
import Accounts from './accounts/accounts';
import Inventory from './inventory/inventory';
import QrScanner from './qr_scanner';
import NewUser from './users/new_user';
import NewAccount from './accounts/new_account';
import Pricing from './pricing/price';
import NoteList from './accounts/notes/note_list';
import NewVendor from './vendor/new_vendor';
import PayVendor from './vendor/pay_vendor';
import VendorPaymentsList from './vendor/vendor_payments';
import VendorPage from './vendor/vendor_page';
import ReportViewer from './reports/reports';
import OrgReportViewer from './reports/org_report';
import SalarySlip from './employee/payslip';
import TransactionList from './accounts/transaction';
import PrintTransactionList from './accounts/print_transection';
import UserPasswordChange from './admin_menu/password_change_screen';
import FinOps from './finops/finops';
import FinReportViewer from './reports/finance';
import TransReportViewer from './reports/transaction';
import DayBookingList from './invoices/daybooking';
import LetterHead from './letterhead/letter_head';
import { LanguageProvider } from './LanguageContext';
import NewDashboard from './NewDashboard';
import SpaxExcel from './finops/excel';
import PublicInvoicesView from './invoices/public_invoice';

const isDay = (new Date().getHours() >= 6 && new Date().getHours() < 18);

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
      background: isDay ? '#ECEFF1' : '#37474F',
    },
    background: {
      paper: isDay ? '#fff' : '#263238',
      pallette: isDay ? 'rgba(255, 255, 255, 0.9)' : 'rgba(38, 50, 56, 0.9)',
      th: isDay ? '#f5f5f5' : '#37474F',
      selected: isDay ? '#f9f9f9' : '#37474F',
    },
    text: {
      primary: isDay ? 'rgba(0, 0, 0, 0.87)' : '#fff',
      secondary: isDay ? 'rgba(0, 0, 0, 0.6)' : 'rgba(255, 255, 255, 0.7)',
    }
  },
});


const dayTheme = createTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<App />} />
            <Route path="*" element={<FileNotFound />} />

            <Route path="/products" element={<Products />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/service" element={<ServiceRequest />} />
            <Route path="/scanner" element={isLogin() ? <QrScanner /> : <App />} />

            <Route path="/register" element={<WorkInProgress />} />
            <Route path="/login" element={<EnterpriseSelect />} />
            <Route path="/login/:company" element={<Login />} />
            <Route path="/logout" element={<Logout />} />
            <Route path="/dashboard" element={isLogin() ? <NewDashboard /> : <App />} />
            <Route path="/lagacy-dashboard" element={isLogin() ? <Dashboard /> : <App />} />

            <Route path="/profile/reset-pass" element={isLogin() ? <UserPasswordChange /> : <App />} />

            <Route path="/desk-booking" element={isLogin() ? <DeskBooking /> : <App />} />
            <Route path="/org-booking" element={isLogin() ? <OrgBooking /> : <App />} />
            <Route path="/pickup-booking" element={isLogin() ? <Pickup /> : <App />} />
            <Route path="/packaging-booking" element={isLogin() ? <Packaging /> : <App />} />
            <Route path="/insurance" element={isLogin() ? <Insurance /> : <App />} />

            <Route path="/client" element={isLogin() ? <ClientList /> : <App />} />
            <Route path="/client/new" element={isLogin() ? <NewClient /> : <App />} />
            <Route path="/client/details/:code" element={isLogin() ? <NewClient /> : <App />} />

            <Route path="/employee" element={isLogin() ? <EmployeeList /> : <App />} />
            <Route path="/employee/salary-slip" element={isLogin() ? <SalarySlip /> : <App />} />
            <Route path="/employee/details/:code" element={isLogin() ? <SalarySlip /> : <App />} />

            <Route path="/vendor" element={isLogin() ? <VendorList /> : <App />} />
            <Route path="/vendor/new" element={isLogin() ? <NewVendor /> : <App />} />
            <Route path="/vendor/pay" element={isLogin() ? <PayVendor /> : <App />} />
            <Route path="/vendor/payments" element={isLogin() ? <VendorPaymentsList /> : <App />} />
            <Route path="/vendor/details/:code" element={isLogin() ? <VendorPage /> : <App />} />

            <Route path="/users" element={isLogin() ? <UserList /> : <App />} />
            <Route path="/users/new" element={isLogin() ? <NewUser /> : <App />} />
            <Route path="/users/details/:code" element={isLogin() ? <App /> : <App />} />

            <Route path="/daybooking" element={isLogin() ? <DayBookingList /> : <App />} />
            <Route path="/invoices" element={isLogin() ? <Invoices /> : <App />} />
            <Route path="/invoices/:code" element={isLogin() ? <CompanyInvoices /> : <App />} />
            <Route path="/invoices/view/:invoice" element={isLogin() ? <ThemeProvider theme={dayTheme}><InvoicesView /></ThemeProvider> : <App />} />
            <Route path="/invoices/public-view/:org/:invoice" element={isLogin() ? <ThemeProvider theme={dayTheme}><InvoicesView /></ThemeProvider> : <PublicInvoicesView />} />

            <Route path="/correction/home" element={isLogin() ? <EditHome /> : <App />} />
            <Route path="/correction/desk-booking" element={isLogin() ? <DeskCnEdit /> : <App />} />
            <Route path="/correction/org-booking" element={isLogin() ? <OrgCnEdit /> : <App />} />
            <Route path="/correction/org-booking/:company" element={isLogin() ? <OrgCnEdit /> : <App />} />
            <Route path="/correction/pickup-booking" element={isLogin() ? <OrgCnPickup /> : <App />} />
            <Route path="/correction/packaging-booking" element={isLogin() ? <OrgCnPackaging /> : <App />} />
            <Route path="/correction/insurance" element={isLogin() ? <InsuranceEdit /> : <App />} />

            <Route path="/billing" element={isLogin() ? <BillingCompany /> : <App />} />
            <Route path="/billing/:client" element={isLogin() ? <Billing /> : <App />} />

            <Route path="/admin" element={isLogin() ? <Admin /> : <App />} />

            <Route path="/fin-ops" element={isLogin() ? <FinOps /> : <App />} />
            <Route path="/fin-ops/excel" element={isLogin() ? <ThemeProvider theme={dayTheme}><SpaxExcel /></ThemeProvider> : <App />} />

            <Route path="/quotation" element={isLogin() ? <QuotationMaker /> : <App />} />

            <Route path="/accounts" element={isLogin() ? <Accounts /> : <App />} />
            <Route path="/accounts/new" element={isLogin() ? <NewAccount /> : <App />} />
            <Route path="/accounts/transaction" element={isLogin() ? <TransactionList /> : <App />} />
            <Route path="/accounts/transaction/:account" element={isLogin() ? <TransactionList /> : <App />} />
            <Route path="/accounts/print-transaction/:account" element={isLogin() ? <ThemeProvider theme={dayTheme}><PrintTransactionList /></ThemeProvider> : <App />} />
            <Route path="/accounts/cash-note" element={isLogin() ? <NoteList /> : <App />} />

            <Route path="/inventory" element={isLogin() ? <Inventory /> : <App />} />

            <Route path="/reports" element={isLogin() ? <ReportViewer /> : <App />} />
            <Route path="/reports/desk" element={isLogin() ? <ReportViewer /> : <App />} />
            <Route path="/reports/org" element={isLogin() ? <OrgReportViewer /> : <App />} />
            <Route path="/reports/finance" element={isLogin() ? <FinReportViewer /> : <App />} />
            <Route path="/reports/transaction" element={isLogin() ? <TransReportViewer /> : <App />} />

            <Route path="/latter-head" element={isLogin() ? <ThemeProvider theme={dayTheme}><LetterHead /></ThemeProvider> : <App />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
